import {combineReducers} from 'redux';
import sessionReducer from './sessionReducer';
import assetsReducer from './assetReducer';
import assetReducer from './assetReducer';
import orderReducer from './orderReducer'
import responsiveReducer from "./responsiveReducer";
import paymentReducer from "./paymentReducer";
import datumReducer from "./datumReducer";
import energyReducer from './energyReducer';
import notificationReducer from "./notificationReducer";
import complaintReducer from "./complaintReducer"
import tataReducer from "./tataReducer";
import subCustomerReducer from "./subCustomerReducer";
import rfidReducer from "./rfidReducer";
import billingReducer from "./billingReducer";
import hazardReducer from './hazardReducer';
import dashboardReducer from './dashboardReducer';
import eventReducer from "./eventReducer";

const rootReducer = combineReducers({
    session: sessionReducer,
    complaint: complaintReducer,
    getAssets: assetsReducer,
    getOrder: orderReducer,
    assetReducer: assetReducer,
    paymentReducer: paymentReducer,
    getWindowSize: responsiveReducer,
    getDatum: datumReducer,
    getEnergy: energyReducer,
    getNotify: notificationReducer,
    getProduct: tataReducer,
    getSubCustDetails: subCustomerReducer,
    getRFIDReducer:rfidReducer,
    getBillingDetails:billingReducer,
    getHazard: hazardReducer,
    dashboard: dashboardReducer,
    event: eventReducer
});

export default rootReducer;